import { createApp } from 'vue'
import App from './App.vue'
const app = createApp(App)

import router from './router'
app.use(router)

import { createPinia } from 'pinia'
const pinia = createPinia()
app.use(pinia)

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/common/css/element-variables.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import elementEn from 'element-plus/dist/locale/en.mjs'
const defLanguage = localStorage.getItem('lang') || "zh"
// import locale from 'element-plus/lib/locale/lang/zh-cn'
app.use(ElementPlus, {
  // 配置中文语言
  locale: defLanguage == 'zh' ? zhCn : elementEn,
  // 或者使用完整语言包
  // locale: locale,
  // 设置组件尺寸
  // size: 'default' as 'default' | 'small' | 'large',
})
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// <img v-lazy="imageUrl" alt="描述" />
import lazyPlugin from 'vue3-lazy'
import loadingImage from '@/assets/lazy.png'
import errorImage from '@/assets/lazy.png'
app.use(lazyPlugin, {
  loading: loadingImage,
  error: errorImage,
  lifecycle: {
    // loading: () => {},
    // error: () => { }
    loaded: (el: any) => {
      el.classList.add('loaded')
    },
  }
})

// 多语言
import en from "@/langurage/en"
import zh from "@/langurage/zh"
import fan from "@/langurage/fan"
import { createI18n } from 'vue-i18n';
const i18n = createI18n({
  legacy: false,  // 设置为 false，启用 composition API 模式
  messages: { en, zh/* , fan */ },
  locale: defLanguage  // 设置默认语言
})
app.use(i18n);

// use copy
import VueClipBoard from 'vue-clipboard2'
app.use(VueClipBoard)

import CEmpty from "@/components/Empty.vue"
app.component("CEmpty", CEmpty)

import DelConfrim from "@/components/DelConfrim.vue"
app.component("DelConfrim", DelConfrim)

import CContainer from "@/components/Container.vue"
app.component("CContainer", CContainer)

app.mixin({
  data() {
    return {
      tableConfig: {
        cellStyle: { fontSize: '14px' },
        headerCellStyle: { fontSize: '14px' },
      }
    }
  }
})

app.mount('#app')
